@if (!isMobileView) {
  <mat-toolbar class="footer">
    <div class="footer-items">
      <a [routerLink]="['liability-disclaimer']" class="footer-link">{{
        translationService.getLiabilityDisclaimerText()
      }}</a>
    </div>
  </mat-toolbar>
} @else {
  <mat-toolbar class="footer-mobile">
    <div class="footer-items">
      <a [routerLink]="['liability-disclaimer']" class="footer-link-mobile">{{
        translationService.getLiabilityDisclaimerText()
      }}</a>
    </div>
  </mat-toolbar>
}
